// extracted by css-extract-rspack-plugin
export default {"fillTextPrimary":"fillTextPrimary__jQMgK","fillBackgroundPrimary":"fillBackgroundPrimary__A5_mg"};